import PropTypes from 'prop-types';
import React from 'react';

import { linkShape, timesShape } from '../../shapes';
import NextAvailableButton from '../containers/NextAvailableButton';
import WithAutoHeight from '../../hoc/WithAutoHeight';
import DateTimePicker from './DateTimePicker';
import ReserveLink from '../../components/ReserveLink';
import WaitingListLink from '../containers/WaitingListLink';

const PickTime = ({
  setActiveDay,
  times,
  selectedTime,
  setTime,
  timezone,
  noTimesAvailable,
  isFetching,
  nextLink,
  waitingListLink,
  shouldShowWaitingList,
  serviceId,
  barberId,
  from,
}) => (
  <div>
    <DateTimePicker
      {...{
        setActiveDay,
        times,
        selectedTime,
        setTime,
        timezone,
        noTimesAvailable,
        isFetching,
        serviceId,
        barberId,
      }}
    />
    {serviceId && selectedTime && <ReserveLink to={nextLink} selectedTime={selectedTime} from={from} />}
    {!isFetching &&
    serviceId &&
    barberId &&
    noTimesAvailable && (
      <div className="layout layout--small layout--center layout--auto">
        <div className="layout__item">
          <NextAvailableButton
            setTime={setTime}
            setActiveDay={setActiveDay}
          />
        </div>
        <div className="layout__item">
          {shouldShowWaitingList && <WaitingListLink to={waitingListLink} from={from} />}
        </div>
      </div>
    )}
  </div>
);
PickTime.propTypes = {
  setActiveDay: PropTypes.func.isRequired,
  times: timesShape,
  selectedTime: PropTypes.string,
  setTime: PropTypes.func.isRequired,
  timezone: PropTypes.string,
  noTimesAvailable: PropTypes.bool,
  isFetching: PropTypes.bool,
  nextLink: linkShape,
  serviceId: PropTypes.string,
  barberId: PropTypes.string,
  shouldShowWaitingList: PropTypes.bool,
  waitingListLink: linkShape,
  from: PropTypes.string.isRequired,
};
PickTime.defaultProps = {
  times: [],
  selectedTime: '',
  timezone: null,
  noTimesAvailable: false,
  isFetching: false,
  nextLink: '',
  serviceId: '',
  barberId: '',
  shouldShowWaitingList: false,
  waitingListLink: '',
};

export default WithAutoHeight(PickTime);



// WEBPACK FOOTER //
// ./src/app/times/components/PickTime.jsx